export default __webpack_public_path__ + "static/media/white-into.49265f66.svg";